import { Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'lfwms-itooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.css']
})
export class TooltipComponent implements OnInit {

  @Input() public tooltipMessage: string;
  @Input() public tooltipPosition: any;
  public msgToDisplay: string = '';
  public positionOfMsg: string;

  constructor() {
  }

  public ngOnInit() {
    this.msgToDisplay = this.tooltipMessage || '';
    this.positionOfMsg = this.tooltipPosition;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/tooltip/tooltip.component.ts